import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import {
  AbstractControl,
  FormControl,
  FormGroup,
  ValidatorFn,
  Validators,
} from "@angular/forms";
import { NavController, NavParams } from "@ionic/angular";
import { Navigator } from "src/app/components/menu/navigator";
import { AuthenticationService } from "src/app/services/authentication/authentication.service";
import { ConfigService } from "src/app/services/config/config.service";
import { RewardsService } from "src/app/services/rewards/rewards.service";
import { EventsService } from "src/app/services/event/event.service";

@Component({
  selector: "app-forgot-password",
  templateUrl: "./forgot-password.component.html",
  styleUrls: ["./forgot-password.component.scss"],
})
export class ForgotPasswordComponent implements OnInit {
  public isComplete: boolean = false;
  public email: AbstractControl;
  public usernameForm: FormGroup;
  showForm: boolean = true;
  public responsibleGamingNumber: string;
  public buttonDisabled: boolean = false;

  public boydCardNoPattern: string = '/^[A-Za-z0-9]{11}$/';
  public emailPattern: string = '/^[a-zA-Z0-9.!#$%&\'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/';

  public username = new FormControl('', [
    Validators.required,
    this.emailOrBoydCardNumberValidator(),
    Validators.maxLength(250),
    Validators.minLength(2)
  ]);
  maxEmailCharacters: number;
  showCardNotFound: boolean;
  boydCardIncorrectCount: number = 0;
  showBoydCardError: boolean;
  public error: any = null;


  @ViewChild("widgetsContent",{read:ElementRef})
  public widgetsContent:ElementRef<any>;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public authService: AuthenticationService,
    public navigator: Navigator,
    protected config: ConfigService,
    public events: EventsService,
    private rewardService: RewardsService
  ) { }

  emailOrBoydCardNumberValidator(): ValidatorFn {
    return (control) => {
      const value = control.value;
      this.maxEmailCharacters = 250;
      const maxUsernameCharacters = 50;
      if (value) {
        if (/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(value) && value.length <= this.maxEmailCharacters) {
          return null; // Valid email
        } else if (/^[A-Za-z0-9]{11}$/.test(value)) {
          return null; // valid boyd card number
        } else if (value.length <= maxUsernameCharacters) {
          return null; // valid username
        } else {
          return { invalidInput: true }; // Invalid input
        }
      }
      return null;
    };
  }

  ngOnInit() {
    this.responsibleGamingNumber =
      this.config.getConfig().RESPONSIBLE_GAMING_NUMBER || "1-800-522-4700";
    this.usernameForm = new FormGroup({
      username: this.username,
    });
    this.email = this.usernameForm.get("email");
  }

  callForgotPassword() {
    this.buttonDisabled = true;
    this.error = null;
    this.showBoydCardError = false;
    let obj = {
      email: this.username.value
    }

    if (/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(this.username.value) && this.username.value.length <= this.maxEmailCharacters) {
      this.usernameForm.value.clientapp = this.config.getClientApp();
      this.authService.callForgotPassword(obj).subscribe(
        (response: any) => {
          this.buttonDisabled = false;
          this.isComplete = true;
          this.showForm = false;
          this.events.publish("event:password:reset", {});
        },
        (error) => {
          // this.isComplete = true;
          // this.showForm = false;
          this.buttonDisabled = false;
          this.scrollToTop();
          this.error = error;
          switch (error.getErrorCode().toUpperCase()) {
            case "HAS_3RD_PARTY_AUTHENTICATION":
              error.setErrorMessage('Please manage your account on the respective app');
              break;
            default:
              error.setErrorMessage((!!error.getPayload()) ? error.getPayload() : "An error has occurred. Please contact support.");
              break;
          }
        }
      );
    }
    else if (/^[A-Za-z0-9]{11}$/.test(this.username.value) || this.username.value) {
      this.rewardService.callIsRewardCardRegistered(this.username.value).subscribe(res => {
        if (res.payload === true) {
          this.buttonDisabled = false;
          this.showCardNotFound = false;
          this.showBoydCardError = false;
          this.navigator.dismiss();
          this.navigator.navigateTo('ResetBoydPasswordComponent', { customModalClass: "crown-modal" });
        } else {
          this.buttonDisabled = false;
          this.boydCardIncorrectCount++;
          this.showBoydCardError = true;
          if (this.boydCardIncorrectCount === 3) {
            this.showCardNotFound = true;
            this.showForm = false;
          }
        }
      },error => {
        this.buttonDisabled = false;
        this.showForm = true;
        error.setErrorMessage(error.getErrorMessage());
        this.error = error;

        if(this.error.error_code === "USER_NOTFOUND_ERROR"){
          this.boydCardIncorrectCount++;
          this.showBoydCardError = true;
          if (this.boydCardIncorrectCount === 3) {
            this.showCardNotFound = true;
            this.showForm = false;
          }
        }

        switch (error.getErrorCode().toUpperCase()) {
          default:
            error.setErrorMessage((!!error.getPayload()) ? error.getPayload() : "An error has occurred. Please contact support.");
            break;
        }
 
        this.scrollToTop();
      })
    }
  }

  scrollToTop(){
    this.widgetsContent.nativeElement.scrollTo({
      top: 0,
      behaviour: "smooth",
    });
   }
}
